import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const linkTextFn = /* @__PURE__ */ createRecipe('link-text', {}, [])

const linkTextVariantMap = {}

const linkTextVariantKeys = Object.keys(linkTextVariantMap)

export const linkText = /* @__PURE__ */ Object.assign(memo(linkTextFn.recipeFn), {
  __recipe__: true,
  __name__: 'linkText',
  __getCompoundVariantCss__: linkTextFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: linkTextVariantKeys,
  variantMap: linkTextVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, linkTextVariantKeys)
  },
  getVariantProps: linkTextFn.getVariantProps,
})